module.exports = __webpack_public_path__ + "organigramme/media/sound.1675b4f4.mp3";